import PropTypes from "prop-types";
import PowerBankerTimeLog from "./power-banker-time-log/power-banker-time-log";

const DashboardPowerBanker = (props) => {
  return (
    <div>
      {(props.powerBankerTimeLogItems) &&
        <PowerBankerTimeLog items={props.powerBankerTimeLogItems}/>
      }
    </div>
  );
};

DashboardPowerBanker.propTypes = {
  powerBankerTimeLogItems: PropTypes.shape({
    User: PropTypes.shape({
      Id: PropTypes.number.isRequired,
      Name: PropTypes.string.isRequired,
    }).isRequired,
    LastUpdated: PropTypes.string,
    OverallCapacity: PropTypes.string,
    OverallCapacityTaskId: PropTypes.number,
    TotalHoursEstimated: PropTypes.number,
    TotalHoursSpent: PropTypes.number,
    Projects: PropTypes.arrayOf(
      PropTypes.shape({
        GroupName: PropTypes.string.isRequired,
        ProjectId: PropTypes.number.isRequired,
        ProjectIdString: PropTypes.string.isRequired,
        TaskId: PropTypes.number.isRequired,
        ProjectName: PropTypes.string.isRequired,
        ClientName: PropTypes.string,
        IsNew: PropTypes.bool,
        IsOverdue: PropTypes.bool,
        LastUpdated: PropTypes.string,
        LastUpdatedString: PropTypes.string,
        LastWeekHours: PropTypes.number,
        WeekendHours: PropTypes.number,
        NextWeekHours: PropTypes.number,
      })
    ).isRequired,
  }),
};

export default DashboardPowerBanker;